module.exports = __webpack_public_path__ + "static/media/trash.6f10f2af.svg";